<div class="p-4 w-full h-full flex align-items-center justify-content-center text-overflow">
  <p class="text-sm text-color m-0">
    {{
      ($isError() ? 'revolution.modules.notification.noNotificationFound' : 'modules.notification.allCaughtUp')
        | translate
    }}
  </p>
</div>
